import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Globe, Edit3 } from 'lucide-react';
import { useAdminEdit } from '@/contexts/AdminEditContext';

const AdminDashboard = () => {
  const { editMode, setEditMode } = useAdminEdit();

  const handleGoToHomepage = () => {
    window.open('/', '_blank');
  };

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground mb-2">Homepage Content Management</h1>
        <p className="text-muted-foreground">Edit homepage content directly with inline editing</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Edit3 className="w-5 h-5" />
            Inline Content Editor
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
            <div>
              <h3 className="font-semibold">Edit Mode</h3>
              <p className="text-sm text-muted-foreground">
                {editMode ? 'Currently active - click on text elements to edit them' : 'Inactive - click to enable editing'}
              </p>
            </div>
            <Button 
              variant={editMode ? "destructive" : "default"}
              onClick={() => setEditMode(!editMode)}
            >
              {editMode ? 'Disable Edit Mode' : 'Enable Edit Mode'}
            </Button>
          </div>

          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              To edit your homepage content, open the homepage and enable edit mode. 
              Then you can click on any text element to edit it directly.
            </p>
            <Button 
              onClick={handleGoToHomepage}
              className="flex items-center gap-2"
              size="lg"
            >
              <Globe className="w-4 h-4" />
              Open Homepage
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboard;